/*
    © 2021 EcomGraduates
*/

// Refresh cart contents (offcanvas cart, cart page, count badges, etc)
window.refreshCartContents = async () => {
    const offcanvasCart = document.querySelector('#offcanvas-cart')
    const cartBadges = document.querySelectorAll('.cart-items-count')
    const cartSummary = document.querySelector('#template-cart-summary')

    offcanvasCart?.classList.add('loading')

    const respoonse = await fetch(window.location.href)
    const data = await respoonse.text()
    const parser = new DOMParser()
    const newDocument = parser.parseFromString(data, 'text/html')

    offcanvasCart?.querySelector('.offcanvas-body')
        .replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-body'))
    offcanvasCart?.querySelector('.offcanvas-footer')
        .replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-footer'))
    cartSummary?.querySelector('.card-body')
        .replaceWith(newDocument.querySelector('#template-cart-summary .card-body'))

    cartBadges.forEach((badge) => {
        badge.style.display = 'block'
        badge.textContent = newDocument.querySelector('.cart-items-count').textContent
    })

    offcanvasCart?.classList.remove('loading')
}

// Quantity Inputs
window.onChangeCartQty = async (input) => {
    await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: input.dataset.lineItemKey,
            quantity: input.value
        })
    })
    window.refreshCartContents()
}

// Cart note - Show button on keydown
window.showNoteButton = (input) => {
    input.closest('.cart-note-wrapper').querySelector('button').style.display = 'block'
}

// Cart note - Save note via ajax
window.saveCartNote = async (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    const note = btn.closest('.cart-note-wrapper').querySelector('[name="note"]').value

    await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note })
    })

    btn.innerHTML = '✓'

    setTimeout(() => {
        btn.innerHTML = btn.dataset.text
    }, 2000)
}

// Checkout button - indicate loading on click
window.onCheckoutBtnClick = (btn) => {
    btn.style.height = btn.clientHeight + 'px'
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
}

// Summary sticky top layout
(() => {
    const cartSummary = document.querySelector('#cart-summary.sticky-top')
    if (cartSummary) {
        const navbarHeight = document.querySelector('#shopify-section-navbar.sticky-top').clientHeight
        cartSummary.style.top = navbarHeight + 20 + 'px'
        cartSummary.style.zIndex = '1019'
    }
})()

// Cart upsells - handle ajax ATC
const initCartUpsellsAjaxATC = () => {
    document.querySelectorAll('#offcanvas-cart-upsells-list .btn-atc')
        .forEach((btn) => {
            btn.addEventListener('click', async (e) => {
                btn.style.height = btn.clientHeight + 'px'
                btn.innerHTML = `
                    <div 
                        class="spinner-border spinner-border-sm" 
                        role="status"
                        style="width: 1rem; height: 1rem">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                `
                const variantId = btn.closest('.product-list-item').querySelector('select[name="id"]').value
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: [{
                            id: Number(variantId),
                            quantity: 1
                        }]
                    })
                })
                fetch(window.location.href)
                    .then((response) => response.text())
                    .then((data) => {
                        const parser = new DOMParser()
                        const newDocument = parser.parseFromString(data, 'text/html')
                        document.querySelector('#offcanvas-cart-inner')?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner'))
                        document.querySelector('#nav-item-cart')?.replaceWith(newDocument.querySelector('#nav-item-cart'))
                        window.initCartQty()
                    })
            })
        })
}
initCartUpsellsAjaxATC()